
const formatLimitedText = (maxChars: number, text?: string) => {

    if (!text) {return "Fail";}
    if (text.length < maxChars) {
        return text;
    }

    return text.slice(0, maxChars) + "...";
}

export default formatLimitedText;